import { ICreateEntradaPUseCase } from "../../../presentation/useCases/create/create_entrada_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class CreateEntradaPUseCase implements ICreateEntradaPUseCase {
  constructor(private readonly repository: IEstoqueRepository) { }

  async createEntradaP(Data: Date | null, dataNotaFiscal: Date | null, IdCentroCusto: number | null, IdProdutoServico: number | null, NroNotaFiscal: string | null, Quantidade: number | null, IdFornecedor: number | null, IdOrdemCompraProduto: number | null, NrNotaFiscal: string | null, IdSessaoMultipla: string | null, ValorUnitario: number | null): Promise<number> {

    const response = await this.repository.createEntradaP(
      Data, dataNotaFiscal, IdCentroCusto, IdProdutoServico, NroNotaFiscal, Quantidade, IdFornecedor, IdOrdemCompraProduto, NrNotaFiscal, IdSessaoMultipla, ValorUnitario
    );
    return response.IdEntradaProduto;
  }
}
